<template>
  <div id="dashboardWrap" class="dark">
    <LazyProSkillManagerSubmissionPathHeader :path-name="t('skillMonitor-assessment-submission')" />
    <LazyProSkillManagerSubmissionContent />
    <LazyProSkillManagerSubmissionPathFooter />
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import {useUserStore} from '~/store/user/userStore';

const { t } = useI18n();
const userStore = useUserStore();
const { guard } = usePermissionGuard();

const handlerAssessmentMenuDoNotHavePermission = () => {
  if (!guard(
      userStore.isPermissionManageAssessment ||
      userStore.isSuperAdminType
  )) return;
}

onMounted(() => {
  handlerAssessmentMenuDoNotHavePermission();
});
</script>

<style>
@import "~/assets/scss/business_style.scss";
</style>